<template>
    <div
        :class="`hasActive eventCard inCard ${disabled ? 'disabled' : ''}`"
        :id="`event-${event.id}`"
        @click="event.link ? goToInPopup(event.link + '?home=1') : () => {};"
    >
        <span :class="`icon`">
            <i
                v-if="event.name === 'comment_reply'"
                class="ion ion-ios-chatbubble"
            />
            <i
                v-else-if="event.name === 'comment_like'"
                class="ion ion-ios-heart"
            />
            <i
                v-else-if="event.name === 'comment_mention'"
                class="ion ion-at"
            />
            <i
                v-else
                class="ion ion-plus-round"
            />
        </span>
        <!-- <span
            v-if="event.name === 'comment_reply'"
            class="icon"
        ><img src="../img/0.2/exploreIcons/ask.svg">
        </span>
        <span
            v-else-if="event.name === 'comment_like'"
            class="icon"
        >
            <img
                src="../img/0.2/exploreIcons/like.svg"
                style="padding: 5px; width: 50px"
            >
        </span>
        <span
            v-else
            class="icon"
        >
            <img src="../img/0.2/exploreIcons/ask.svg">
        </span> -->
        <div class="title">{{ event.title }}</div>
        <div class="subtitle">{{ event.subtitle }}</div>
        <div
            v-if="event.read"
            class="status completed"
        >SEEN</div>
        <div
            v-else
            class="status"
        >NEW</div>

    </div>
</template>

<script>
export default {
    props: ['event', 'disabled'],
    store: ['api'],
    data () {
        return {};
    },
    watch: {},
    created: function () { },
    beforeDestroy: function () { },
    methods: {
        goToInPopup: function (url) {
            if (this.disabled) return;
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                this.read = true;
                f7.popup.get('#popup').open();
            }, 250);
            // f7.statusbar.setTextColor('white');
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.eventCard {
    &.disable {
        .icon,
        .title,
        .subtitle,
        .status {
            opacity: 0.35 !important;
        }
    }
    cursor: pointer;
    // background: @background;
    // border: 0.33px solid #eee;
    // width: 90%;
    // padding: 13px 10px 10px 20px;
    margin: 0px auto 0px;
    padding: 10px 10px 6px 10px;
    &.inCard {
        background: white;
        border-radius: 12px;
        margin: 12px 16px;
    }
    text-align: center;
    -webkit-transform: translate3d(0%, 0%, 0);
    transform: translate3d(0%, 0%, 0);
    .icon {
        float: left;
        border-radius: 50%;
        height: 38px;
        width: 38px;
        line-height: 38px;
        font-size: 20px;
        background-color: @coral;
        color: white;
        border: 2px solid white;
        z-index: 99;
        position: relative;
    }
    &.completed .icon {
        background-color: #ccc;
    }
    .inner:not(.lastOne):not(.inCard):before {
        z-index: 98;
        content: ' ';
        top: 36px;
        position: absolute;
        width: 4px;
        height: ~'calc(100% - 22px)';
        left: 29px;
        background: @coral;
        transform: translate3d(-50%, 0, 0);
    }
    &.completed {
        .inner:not(.lastOne):not(.inCard):before {
            background: #ccc;
        }
    }
    .title {
        margin-left: 49px;
        padding-top: 6px;
        font-family: AndesLight;
        font-size: 18px;
        color: #111;
        text-align: left;
    }
    &.completed .title {
        color: #808080;
    }
    .subtitle {
        margin-left: 49px;
        padding-top: 4px;
        font-family: AndesLight;
        font-size: 15px;
        text-align: left;
        line-height: 15px;
        color: @darkGray;
    }
    .status {
        margin-left: 53px;
        text-transform: uppercase;
        padding-top: 10px;
        font-family: AndesMedium;
        font-size: 15px;
        text-align: left;
        color: @coral;
        .time {
            padding-left: 10px;
            color: #ccc;
        }
    }
    .completed {
        color: #809c92;
    }
    &.active-state {
        background: transparent; // dint loook good
    }
}
.theme-dark {
    .eventCard {
        &.inCard {
            background: #000;
        }
        &.active-state {
            background: transparent;
        }
        .icon {
            border: 2px solid #000;
        }
        .title {
            color: white;
        }
    }
}
</style>
